(function(){
  var SEL='.filepond--drop-label label,[data-upload-field] .filepond--drop-label label';
  function fix(){
    document.querySelectorAll(SEL).forEach(function(l){
      var root=l.closest('.filepond--root');
      var done=root&&root.querySelector('.filepond--item');
      var want=done?'Uploaded \u2713':'Upload';
      if(l.textContent!==want||l.children.length){l.textContent=want;}
      l.setAttribute('data-fp-text',want);
      if(root)root.classList.toggle('fp-has-file',!!done);
    });
  }
  var t;function q(){clearTimeout(t);t=setTimeout(fix,30);}
  function start(){
    fix();
    new MutationObserver(q).observe(document.body,{childList:true,subtree:true,characterData:true});
    document.addEventListener('FilePond:addfile',q);
    document.addEventListener('FilePond:processfile',q);
    document.addEventListener('FilePond:removefile',q);
    document.addEventListener('FilePond:init',q);
    var n=0,iv=setInterval(function(){fix();if(++n>=20)clearInterval(iv);},250);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
